import { createSlice } from "@reduxjs/toolkit";
import { getCustomersRatingReviewAPI } from "../../api/ratingreview";

const data = {
  isLoading: false,
  error: "",
  message: null,
  data: null,
}; 

const getCustomersRatingReviewSlice = createSlice({
  name: "getCustomersRatingReview",
  initialState: data,
  reducers: {
   getCustomersRatingReviewSlice(state) {
      state.isLoading = true;
    },
   getCustomersRatingReviewSliceSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
    getCustomersRatingReviewSliceFailure(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
   getCustomersRatingReviewSliceReset(state) {
      state.isLoading = false;
      state.data = null;
    },
  },
});
export const getCustomersRatingReviewHandler = (search:any,page:any,limit:any,sort_by:any,sort_direction:any) => async (dispatch: any) => {
  try {
    dispatch(getCustomersRatingReviewAction.getCustomersRatingReviewSlice());
    const response: any = await getCustomersRatingReviewAPI(search,page,limit,sort_by, sort_direction);
    
    dispatch(getCustomersRatingReviewAction.getCustomersRatingReviewSliceSuccess(response));
  } catch (e: any) {
    dispatch(getCustomersRatingReviewAction.getCustomersRatingReviewSliceFailure(e?.response?.data));
  }
};
export default getCustomersRatingReviewSlice.reducer;
export const getCustomersRatingReviewAction = getCustomersRatingReviewSlice.actions;
